import { motion } from 'framer-motion';
import bespokeImage2 from "../assets/bespoke2.png"; // Assuming this path

const BespokePortfolios: React.FC = () => {
  return (
    <div className="bg-white">

      {/* SECTION 2: CORE PHILOSOPHY (Image Left, Text Right) */}
      <section className="py-24 bg-slate-50/50 overflow-hidden">
        <div className="max-w-7xl mx-auto px-6 lg:px-24">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 items-center">
            
            {/* Swapped: Image on the Left */}
            <motion.div 
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="lg:col-span-7 flex justify-center items-center order-2 lg:order-1"
            >
              <div className="relative w-full max-w-[550px] mr-12">
                <img 
                  src={bespokeImage2} 
                  alt="Core Philosophy Illustration" 
                  className="w-full h-auto object-contain"
                />
              </div>
            </motion.div>

            {/* Swapped: Content on the Right */}
            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="lg:col-span-5 order-1 lg:order-2"
            >
              <h3 className="text-[24px] md:text-[40px] font-[450] text-gray-900 tracking-tight mb-6">
                Core Philosophy
              </h3>
              <div className="space-y-6 max-w-xl">
               
                <p className="text-slate-600 text-lg md:text-xl leading-relaxed">
                  Enduring wealth is shaped by suitability-driven allocation aligned with risk capacity, financial priorities, and long-term objectives.
                </p>
                <p className="text-slate-600 text-lg md:text-xl leading-relaxed">
                  Short-term narratives do not define long-term outcomes. The emphasis remains on governance, consistency, and measured progression across market environments.
                </p>

                <p className="text-slate-500 text-base md:text-lg font-medium border-l-4 border-red-600 pl-6 py-2 mt-8 italic">
      Disciplined allocation. Continuous monitoring. Balanced growth.
    </p>
              </div>
            </motion.div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default BespokePortfolios;